var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-widget"},[_c('CCard',{attrs:{"body-wrapper":""}},[_c('div',{staticClass:"header"},[_vm._t("header")],2),_c('div',{staticClass:"pt-2"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }